// extracted by mini-css-extract-plugin
module.exports = {"composeWrapper":"ComposeArea_composeWrapper__2Jspl","sendBtn":"ComposeArea_sendBtn__18sDN"};